import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const TagService = sdk.getService('TagService');

export const useTagsByAcademy = (academyIdOrSlug: string) => {
  const { isLoading, data } = useQuery({
    queryKey: ['tags', 'by-academy', academyIdOrSlug],
    queryFn: () => TagService.getTagsByAcademy(academyIdOrSlug),
    enabled: Boolean(academyIdOrSlug)
  });

  return {
    tags: data,
    isLoading
  };
};
